<template>
  <div class="entered-password">
    <div class="entered-password__title">{{ $t("Forgot your password ?") }}</div>
    <div class="entered-password__p">{{ $t("To get my password, I enter my email address:") }}</div>
    <div v-if="passwordError" class="error">
      <SvgImage
        class="error__icon"
        height="20"
        icon="Icon_attention"
        width="24"
      />
      {{ $t("Thanks! If there is an account registered with the") }} {{ form.email }},
      {{ $t("you will find message with a password reset link in your inbox.") }}
    </div>

    <form class="form" @submit.prevent="EmailNewPassword">
      <ValidationProvider
        v-slot="{ errors }"
        rules="required|email"
      >
        <div class="form__field">
          <label
            :class="(errors[0] || hasUserErrors) && 'form__label--error'"
            class="form__label"
        >{{ $t('Your email') }}</label>
          <input ref="email"
            v-model="form.email"
            :class="errors[0] && 'form__input--error'"
            class="logins-input form__input"
            name="email"
            placeholder=" "
            type="email"
          >
        </div>
        <div v-if="errors[0]" class="error-msg">{{ $t(errors[0]) }}</div>
      </ValidationProvider>

      <SfButton
        v-e2e="'login-modal-submit'"
        :disabled="loading"
        class="sf-button--full-width login-btn sf-button__primary"
        type="submit"
      >
        <div>{{ $t('Valider') }}</div>
      </SfButton>
    </form>

    <SfButton
      v-e2e="'login-modal-submit'"
      :disabled="loading"
      class="sf-button--full-width return-btn sf-button__secondary"
      type="submit"
      @click="$router.push(`${localePath('/acces-espace-pro')}`)"
    >
      <div>{{ $t('To cancel') }}</div>
    </SfButton>
  </div>
</template>

<script>
import { email, required } from 'vee-validate/dist/rules';
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { useForgotPassword } from '../../composables/useForgotPassword';
import SvgImage from '~/components/General/SvgImage.vue';
import { SfButton, SfLoader, } from '@storefront-ui/vue';
import { extend, ValidationProvider } from 'vee-validate';

extend('required', {
  ...required,
  message: 'This field is required',
});

extend('email', {
  ...email,
  message: 'Invalid email',
});

export default defineComponent({
	layout:'login',
  name: 'ForgotPassword',
  components: {
    SfButton,
    SfLoader,
    ValidationProvider,
    SvgImage
  },
  middleware: 'is-guest',
  setup() {
    const form                                                                    = ref({});
    const emailInput                                                              = ref('');
    const passwordError                                                           = ref(false);
    const { result, request: resetPassword, error: forgotPasswordError, loading } = useForgotPassword();

    const EmailNewPassword = async () => {
      await resetPassword({ email: form.value.email, token: null });
      passwordError.value = true;
    };

    return {
      EmailNewPassword,
      form,
      emailInput,
      result,
      forgotPasswordError,
      passwordError,
      loading
    }
  }
});
</script>

<style lang="scss">
@import '@/assets/theme/scss/pages/acces-espace-pro.scss';
</style>
